
import { Cell, CellGroup } from 'vant'
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      // 公众号
      nowImei: $cookies.get('imei'),
      cameraType: this.$store.state.devCameraList.length > 0 ? this.$store.state.devCameraList[0].name : '暂无摄像头',
      cameraTypeValue: this.$store.state.devCameraList.length > 0 ? this.$store.state.devCameraList[0].value : 0,
      videoTime: '15秒',
      videoTimeValue: 15,
      // 下拉选择(摄像头)
      showActionSheetCamera: false,
      cameraTypeList: this.$store.state.devCameraList,
      // cameraTypeList: [
      //   { name: '前置摄像头', value: 1 },
      //   { name: '后置摄像头', value: 2 },
      //   { name: '前+后摄像头', value: 3 }
      // ],
      // 下拉选择(视频时长)
      showActionSheetVideoTime: false,
      videoTimeList: [
        { name: '5秒', value: 5 },
        { name: '10秒', value: 10 },
        { name: '15秒', value: 15 }
      ],
      // 照片或视频地址
      imgArray: [],
      player:'',
      isangle:false,
    }
  },
  methods: {
    // 选择摄像头
    selectCameraFn () {
      this.showActionSheetCamera = true;
    },
    onSelectCameraFn (item) {
      this.cameraType = item.name;
      this.cameraTypeValue = item.value;
      this.showActionSheetCamera = false;
    },
    // 选择视频时长
    selectVideoTimeFn () {
      this.showActionSheetVideoTime = true
    },
    onSelectVideoTimeFn (item) {
      this.videoTime = item.name;
      this.videoTimeValue = item.value;
      this.showActionSheetVideoTime = false;
    },
    // 拍照请求
    takePictureFn () {
      let _this = this;
      let times = this.videoTimeValue;
      this.imgArray = [];
      // 录像过程中提示用户
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '正在录制...' + times
      });
      let setIntervalText = setInterval(function () {
        times--;
        if (times > 0) {
          _this.$toast.loading({
            mask: true,
            duration: 0,
            message: '正在录制...' + times
          });
        } else {
          _this.$toast.loading({
            mask: true,
            duration: 0,
            message: '正在获取视频'
          });
          clearInterval(setIntervalText)
        }
      }, 1000);
      this.$axios.post('/v3/u/action/realTimeVideo', { camera: this.cameraTypeValue, duration: this.videoTimeValue }, { timeout: this.$store.state.timeoutLongTime + 30000 })
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          clearInterval(setIntervalText);
          if (response.data.ret === 0) {
            // let imgArray = [];
            // for (let i = 0; i < imgData.length; i++) {
            //   imgArray.push({
            //     typeName: imgData[i].type === 1 ? '前置摄像头视频' : imgData[i].type === 2 ? '后置摄像头视频' : '摄像头视频',
            //     // imgUrl: decodeURIComponent(imgData[i].url)
            //     imgUrl: imgData[i].url,
            //     imgThumb: decodeURIComponent(imgData[i].url_thumb)
            //   })
            // }
            // _this.imgArray = imgArray;
            let imgData = response.data.data|| [];
            _this.imgArray = imgData.map(item=>{
              return {
              ...item,
              typeName: item.camera === 1 ? '前置摄像头视频' : item.camera === 2 ? '后置摄像头视频' : '全景摄像头视频',
            }});
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '录像失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          clearInterval(setIntervalText);
          _this.$toast.clear();
          errorModal(error, 131);
        })
    },
    change3DVideo(item,id='d3Video'){
      setTimeout(()=>{
        this.player = new EapilRender(document.getElementById(id), {
          poster:'',
          DataType: EapilRender.DATATYPE.MP4,
          RoateXY: { "xValue": 0, "yValue": 0 },
          SourceUrl: item.url,
          Template: localStorage.getItem('cameraTemplate'),
        });
      },180)
    },
    fullScreenHandle(item,type){
      window.scroll(0,0);
      document.body.style.overflow = 'hidden'
      this.isshow = true;
      this.d3Type = item.mtype;
      this.d3item = item;
      this[type](item,'demoVideo')
    },
    closeHandle(){
        document.body.style.overflow = 'auto'
        this.cleanCache()
        this.isshow = false;
        this.key = Math.random();
    },
    cleanCache(){
      try {
        this.player.destroy()
      } catch (error) {
        document.getElementById('demoVideo').innerHTML = ''
      }
    },
    // 跳转到查询页面
    queryPictureFn () {
      this.$router.push('/queryMedia?type=2')
    },
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    }
  },
  created () {
    // localStorage 删除本地存储(用户的查询条件)
    localStorage.removeItem('xjWxQueryMediaStartTime');
    localStorage.removeItem('xjWxQueryMediaEndTime');
    localStorage.removeItem('xjWxQueryMediaCamera');
    localStorage.removeItem('xjWxQueryMediaPictureType');
  },
  destroyed () {
    this.$toast.clear();
  }
}
